const Globals = {};

export default Globals;